// @ts-nocheck

export const DefaultVisibleSetsNumbers = {
  TENNIS: 3,
  ICEHOCKEY: 3,
  LAST_SET_AS_GAME_SCORE: 4,
  BASEBALL: 3,
  BASKETBALL_AND_FOOTBALL: 4,
};

export const NumberPeriodsBySport = {
  BASEBALL: 9,
  BASKETBALL_AND_FOOTBALL: 4,
  AUSTRALIAN_FOOTBALL: 4,
  NCAA: 2,
  ICEHOCKEY: 3,
};
